module.exports = __webpack_public_path__ + "img/boundary-show.92cfd674.svg";